import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";

function Dropdown({ label, optionCls = "", menus }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <div className="cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
        {label}
      </div>

      {isOpen && menus?.length ? (
        <div
          className={`absolute bg-white rounded-md shadow-md border border-gray-300 min-w-[150px] text-gray-700 ${
            optionCls || "bottom-0 right-0"
          }`}
        >
          {menus?.map((menu, i) => {
            const { label, onClick } = menu;

            return (
              <button
                key={i}
                onClick={() => {
                  onClick();
                  setIsOpen(false);
                }}
                className={`px-4 py-3 nav_link hover:text-white transistion ease-in-out duration-300 rounded-md w-full text-left ${
                  i === 0 ? "" : "border-t"
                }`}
              >
                {label}
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}

export default Dropdown;
